<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>基本工资单说明:</h5><br>
				<span>1、业务说明:一旦使用就不能修改,只能通过基本工资变更单进行更新</span><br>
				<span>2、添加变更记录后，点击提交数据生效。</span><br>
				<span>3、查询关键字:部门、人员。</span><br>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<!-- <template slot="pre_base_button">
        <button class="pre_btn_ok" @click="fun_base_history">变更基本工资</button>
      </template> -->

		</pre-base>

		<!-- 弹出待办业务单号 start -->
		<div class="top_sheetno" id="pre_detail_data" v-show="show_salary_update">
			<span class="top_sheetno_close">
				<img src="../../assets/image/shan1.png" @click="closeshow" />
			</span>
			<div class="content_edit ">
				<h3 class="red">变更业务</h3>
			</div>
			<div v-loading="element_loading" element-loading-text="拼命加载中......"
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
				class="content_edit salary">
				<div class="content_edit_item salary-edit">
					<label>姓名:</label>
					<input type="text" class="short0" v-model="user_name" readonly="readonly" />

				</div>
				<div class="content_edit_item salary-edit">
					<label>基本工资:</label>
					<input type="text" class="short0" v-model="s_base" readonly="readonly" />
					<label>岗位绩效:</label>
					<input type="text" class="short0" v-model="s_role" readonly="readonly" />
					<label>交通补贴:</label>
					<input type="text" class="short0" v-model="s_butie" readonly="readonly" />
					<label>餐补贴:</label>
					<input type="text" class="short0" v-model="can_butie" readonly="readonly" />
					<label>话补贴:</label>
					<input type="text" class="short0" v-model="hua_butie" readonly="readonly" />

				</div>
				<div class="content_edit_item salary-edit">
					<label>新基本工资:</label>
					<input type="text" class="short0" v-model="new_base" @keyup.enter="fun_salar_upd('_add')" />
					<label>新岗位绩效:</label>
					<input type="text" class="short0" v-model="new_role" @keyup.enter="fun_salar_upd('_add')" />
					<label>新交通补贴:</label>
					<input type="text" class="short0" v-model="new_butie" @keyup.enter="fun_salar_upd('_add')" />
					<label>新餐补贴:</label>
					<input type="text" class="short0" v-model="new_can_butie" @keyup.enter="fun_salar_upd('_add')" />
					<label>新话补贴:</label>
					<input type="text" class="short0" v-model="new_hua_butie" @keyup.enter="fun_salar_upd('_add')" />

				</div>
				<div class="content_edit_item salary-edit">
					<label>变更说明:</label>
					<input type="text" class="long2" v-model="note" @keyup.enter="fun_salar_upd('_add')" />

				</div>
				<div class="my_btn">
					<button @click="fun_salar_upd('_add')">新增</button>
				</div>
				<div class="pre_tab ">

					<table class="dataintable" border="1" cellpadding="2" cellspacing="1">
						<tr class="tab_header_new">
							<th>序号</th>
							<th class="short0">姓名</th>
							<th class="short0">状态</th>
							<th class="short1">原基本工资</th>
							<th class="short1">原岗位绩效</th>
							<th class="short1">原岗位补贴</th>
							<th class="short1">原餐补贴</th>
							<th class="short1">原话补贴</th>
							<th class="short1">新基本工资</th>
							<th class="short1">新岗位绩效</th>
							<th class="short1">新岗位补贴</th>
							<th class="short1">新餐补贴</th>
							<th class="short1">新话补贴</th>
							<th>备注</th>
							<th>更新时间</th>
							<th>编辑</th>
						</tr>
						<tr :id="'do_'+item.row_num" v-for="item in list_salary_history" @click="fun_sel(item)">
							<!-- <a href="#"> -->
							<td>{{item.row_num}}</td>
							<td class="short0">{{item.u2_name}}</td>
							<td class="short0">{{item.flag}}</td>
							<td class="short1">{{item.s_base}}</td>
							<td class="short1">{{item.s_role}}</td>
							<td class="short1">{{item.s_butie}}</td>
							<td class="short1">{{item.can_butie}}</td>
							<td class="short1">{{item.hua_butie}}</td>
							<td class="short1">{{item.new_base}}</td>
							<td class="short1">{{item.new_role}}</td>
							<td class="short1">{{item.new_butie}}</td>
							<td class="short1">{{item.new_can_butie}}</td>
							<td class="short1">{{item.new_hua_butie}}</td>
							<td>{{item.note}}</td>
							<td>{{item.upd_date}}</td>
							<td><button @click="fun_salar_upd('_sub',item)">提交</button>
								<button @click="fun_salar_upd('_del',item)">删除</button>
							</td>
						</tr>
					</table>

				</div>

			</div>
		</div>
		<!-- 弹出待办业务单号 end -->
	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Method_EasySelect,
		Method_Common,
		Select_PageLength
	} from '@/utils/loadhttpdata.js';
	export default {
		components: {
			"pre-base": () => import("../auto/old_view_v1.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',
				// 下拉菜单
				// list_fee: [],
				// sel_fee: {},
				element_loading: false,
				show_salary_update: false,
				row_id: 0,
				sys_date: '',
				user_name: '',
				s_base: '',
				s_role: '',
				s_butie: '',
				can_butie: '',
				hua_butie: '',
				new_base: '',
				new_role: '',
				new_butie: '',
				new_can_butie: '',
				new_hua_butie: '',
				note: '',
				list_salary_history: []
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: async function() {

				let t_list_department = [],
					t_list_flag = [],
					t_list_user = [];

				t_list_department = await this.loadClass('data_exp_item_class', '', '', 'dep');

				// t_list_flag = await this.loadClass('data_flag');


				t_list_user = await this.loadClass('data_alluser');

				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '基本工资单',
					"control": "salarybase",
					"isTwo": "0",
					"isTwoDetail": "0",
					"isFileMain": "1",
					"sel_action": 'exp_kq_salary_base',
					"upd_action": 'exp15_kq_salary_base',
					"step": '1',
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": 'kq',
					"p2": '',
					"p3": '',
					"parm_sel": [{
							"name": "部门",
							"val": "",
							"key": "d_name",
							"type": "select",
							"class": "long1",
							"list": t_list_department.data,
							"sel_val": {},
							"sel_name": "",
							"sel": "1"
						},
						{
							"name": "申请人",
							"val": "",
							"key": "u2_name",
							"type": "select",
							"class": "long1",
							"list": t_list_user.data,
							"sel_val": {},
							"sel_name": "",
							"sel": "2"
						}
					],
					"parm": [{
							"name": "部门",
							"val": "",
							"key": "d_name",
							"type": "text",
							"class": "long1",
							"x": "1",
							"r": "1",
							"p": "0",

						},
						{
							"name": "申请人",
							"val": "",
							"key": "u2_name",
							"type": "select",
							"class": "long1",
							"list": t_list_user.data,
							"sel_val": {},
							"sel_name": "",
							"w": "1",
							"p": "1",
							"x": "1"
						},
						{
							"name": "基本工资",
							"val": "",
							"key": "s_base",
							"type": "number",
							"class": "long1",
							"x": "1",
							"p": "1",
							"x": "2"
						},
						{
							"name": "岗位绩效",
							"val": "",
							"key": "s_role",
							"type": "number",
							"class": "long1",
							"w": "1",
							"p": "1",
							"x": "2"
						},
						{
							"name": "交通补贴",
							"val": "",
							"key": "s_butie",
							"type": "number",
							"class": "long1",
							"w": "1",
							"p": "1",
							"x": "2"
						},
						{
							"name": "餐补贴",
							"val": "",
							"key": "can_butie",
							"type": "number",
							"class": "long1",
							"w": "1",
							"p": "1",
							"x": "3"
						},
						{
							"name": "话补贴",
							"val": "",
							"key": "hua_butie",
							"type": "number",
							"class": "long1",
							"w": "1",
							"p": "1",
							"x": "3"
						},
						{
							"name": "社保补贴",
							"val": "",
							"key": "shebao_butie",
							"type": "number",
							"class": "long1",
							"w": "1",
							"p": "1",
							"x": "4"
						},
						{
							"name": "安全奖",
							"val": "",
							"key": "anquanjiang",
							"type": "number",
							"class": "long1",
							"w": "1",
							"p": "1",
							"x": "4"
						},
						{
							"name": "工龄工资",
							"val": "",
							"key": "gongling",
							"type": "number",
							"class": "long1",
							"w": "1",
							"p": "1",
							"x": "4"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"x": "4"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						// {
						//   "name": "申请单"
						// },
						{
							"name": "部门"
						},
						{
							"name": "人员姓名"
						},
						{
							"name": "状态"
						},
						{
							"name": "同步状态"
						},
						{
							"name": "合计"
						},
						{
							"name": "基本工资"
						},
						{
							"name": "岗位绩效"
						},
						{
							"name": "交通补贴"
						},
						{
							"name": "餐补贴"
						},
						{
							"name": "话补贴"
						},
						{
							"name": "社保补贴"
						},
						{
							"name": "安全奖"
						},
						{
							"name": "工龄工资"
						},
						{
							"name": "备注"
						},
						{
							"name": "录入人"
						},
						{
							"name": "更新时间"
						}
					],
					"d_parm": [],
					"d_name": []
				});

			},
			refresh_data: function(type, page) {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data(type, page);
				});
			},
			refresh_father: function(type, val, parm) {
				// console.log('type=' + type + ' val=' + val);

				if (this.show_salary_update) {
					this.fun_base_history();
				}

				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					case 'blank':
						// 清空下拉菜单选项 没有起作用
						console.log('清空下拉菜单');
						this.sel_depart = {};
						break;
						// case 'slot_c_out_fee':
						//   this.selectFunc1(val);
						//   if (val == 'clear') {
						//     this.$refs['out_fee'].clearselect();
						//   }
						//   break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			},
			fun_base_history: function() {


				if (typeof(this.item) == 'undefined' || this.item == '') {
					this.$message({
						message: '请选择要编辑的数据!',
						type: 'error'
					});

					return;
				}

				// console.log(this.item);
				this.user_name = '';
				this.s_base = '';
				this.s_role = '';
				this.s_butie = '';

				this.new_base = '';
				this.new_role = '';
				this.new_butie = '';

				this.user_name = this.item[3].val;
				this.s_base = this.item[5].val;
				this.s_role = this.item[6].val;
				this.s_butie = this.item[7].val;

				this.can_butie = this.item[8].val;
				this.hua_butie = this.item[9].val;

				this.new_base = this.s_base;
				this.new_role = this.s_role;
				this.new_butie = this.s_butie;

				this.show_salary_update = true;
				this.fun_load_history();

			},
			closeshow: function() {
				this.show_salary_update = false;
				this.refresh_data('', 1);
			},
			fun_sel: function(d) {
				this.user_name = '';
				this.s_base = '';
				this.s_role = '';
				this.s_butie = '';
				this.row_id = '';
				this.note = '';

				this.new_base = '';
				this.new_role = '';
				this.new_butie = '';

				this.can_butie = '';
				this.hua_butie = '';

				this.new_can_butie = '';
				this.new_hua_butie = '';

				this.user_name = d.u2_name;
				this.s_base = d.s_base;
				this.s_role = d.s_role;
				this.s_butie = d.s_butie;

				this.new_base = d.new_base;
				this.new_role = d.new_role;
				this.new_butie = d.new_butie;

				this.can_butie = d.can_butie;
				this.hua_butie = d.hua_butie;

				this.new_can_butie = d.new_can_butie;
				this.new_hua_butie = d.new_hua_butie;

				this.note = d.note;
				this.row_id = d.id;
			},
			fun_salar_upd: function(type, item) {
				// console.log(item);
				if (type == '_add') {
					let d = [];
					d.push(this.user_name);
					d.push(this.s_base);
					d.push(this.s_role);
					d.push(this.s_butie);
					d.push(this.can_butie);
					d.push(this.hua_butie);
					d.push(this.new_base);
					d.push(this.new_role);
					d.push(this.new_butie);
					d.push(this.new_can_butie);
					d.push(this.new_hua_butie);
					d.push(this.note);
					this.fun_com_upd(type, this.row_id, this.sys_date, d);
				}

				if (type == '_del') {
					this.$confirm('此操作将删除当前数据,并返回上一次修改记录, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						let d = [];
						d.push(item.u2_name);
						d.push(item.s_base);
						d.push(item.s_role);
						d.push(item.s_butie);
						d.push(item.can_butie);
						d.push(item.hua_butie);
						d.push(item.new_base);
						d.push(item.new_role);
						d.push(item.new_butie);
						d.push(item.new_can_butie);
						d.push(item.new_hua_butie);
						d.push(item.note);

						this.fun_com_upd(type, item.id, item.sys_date, d);
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
				}

				if (type == '_sub') {
					let d = [];
					d.push(item.u2_name);
					d.push(item.s_base);
					d.push(item.s_role);
					d.push(item.s_butie);
					d.push(item.can_butie);
					d.push(item.hua_butie);
					d.push(item.new_base);
					d.push(item.new_role);
					d.push(item.new_butie);
					d.push(item.new_can_butie);
					d.push(item.new_hua_butie);
					d.push(item.note);
					this.fun_com_upd(type, item.id, item.sys_date, d);
				}



			},
			fun_com_upd: function(action, id, date, d) {
				this.element_loading = true;

				this.$post(
					api.http_method, Method_Common('data_salary_history' + action, id, date, d)
				).then(res => {
					res = JSON.parse(res);
					// console.log(res.data);
					this.element_loading = false;
					if (res.data.status == '1') {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.fun_load_history();

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

			},
			fun_load_history: function() {
				this.list_salary_history = [];
				this.element_loading = true;

				this.$post(
					api.http_method, Select_PageLength('data_salary_history', 1, 10, '', this.user_name)
				).then(res => {
					res = JSON.parse(res);
					// console.log(res.data);
					this.element_loading = false;
					if (res.data.status == '1') {
						this.list_salary_history = res.data.data;
						// console.log(this.list_salary_history);
					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});
			}





		}
	};
</script>
<style scoped="scoped">
	.top_sheetno {
		position: absolute;
		top: 16%;
		left: 10%;
		background-color: rgba(0, 0, 0, 0.5);
		/* opacity: 0.2; */
		/* border: 1px solid black; */
		/* padding-left: 20px; */
		/* padding-right: 20px; */
		border-radius: 5px;
		z-index: 3;
		width: 80%;
		text-align: center;
		padding: 20px;
		overflow-x: auto;
	}

	.top_sheetno_close>img {
		width: 24px;
		height: auto;
		position: absolute;
		right: 24px;
		top: 24px;
		cursor: pointer;
	}

	.salary {
		padding-bottom: 20px;
	}

	.salary>div {
		margin-top: 10px;
	}

	.salary-edit {
		display: inline-block;
		width: 100%;
	}

	.salary-edit>label {
		display: inline-block;
		width: 108px;
	}
</style>
